import { isWeb } from 'shared/constants/platform';
import getEnvironmentVar from 'shared/utils/getEnvironmentVar';

export type SessionData = {
  sessionId: string;
  modules: {
    module: 'CCA';
    loaded: boolean;
  }[];
};

export type ThreeDsValidationResponse = {
  Validated: boolean;
  ActionCode: string;
  ErrorNumber: number;
  ErrorDescription: string;
  Payment: {
    Type: 'CCA';
    ExtendedData: {
      Amount: string;
      CAVV: string;
      CurrencyCode: string;
      ECIFlag: string;
      PARes: string;
      ThreeDSVersion: string;
      PAResStatus: 'Y' | 'N' | 'U';
      SignatureVerification: 'Y' | 'N';
    };
    ProcessorTransactionId: string;
  };
};

const CARDINAL_IFRAME_STYLES = `
  #Cardinal-CCA-IFrame,
  #Cardinal-Modal,
  #Cardinal-Modal div {
    width: 33vw !important;
    height: 90vh !important;
    max-width: 50vw !important;
    max-height: 100vh !important;
    display: block !important;
    position: fixed !important;
  }
  @media (max-width: 768px) {
    #Cardinal-CCA-IFrame,
    #Cardinal-Modal,
    #Cardinal-Modal div {
      width: 95vw !important;
      height: 85vh !important;
      max-width: 95vw !important;
      max-height: 90vh !important;
      display: block !important;
      position: fixed !important;
    }
  }
`;

export const cleanupCardinalListeners = () => {
  if (typeof Cardinal !== 'undefined' && Cardinal.off) {
    Cardinal.off('payments.setupComplete');
    Cardinal.off('payments.validated');
  }
};

export const cleanupCardinalDOM = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  cleanupCardinalListeners();

  try {
    const iframes = document.querySelectorAll(
      'iframe[src*="cardinalcommerce"]',
    );
    const modals = document.querySelectorAll(
      '#Cardinal-Modal, #Cardinal-CCA-IFrame',
    );

    [...iframes, ...modals].forEach((el) => el.remove());

    const script = document.getElementById('three-ds-sdk-web');
    script?.remove();
  } catch (error) {
    console.warn('Failed to cleanup Cardinal DOM elements', error);
  }
};

export const injectCardinalScript = (onLoad: () => void) => {
  if (typeof document === 'undefined') {
    return;
  }
  const scriptId = 'three-ds-sdk-web';
  if (!document.getElementById(scriptId) && isWeb) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = getEnvironmentVar('EXPO_THREE_DS_SDK_WEB_URL');
    script.async = true;
    script.integrity = getEnvironmentVar('EXPO_TABAPAY_INTEGRITY_STRING');
    script.crossOrigin = 'anonymous';
    script.onload = () => {
      onLoad();
      const style = document.createElement('style');
      style.innerHTML = CARDINAL_IFRAME_STYLES;
      document.head.appendChild(style);
    };
    document.body.appendChild(script);
  } else {
    onLoad();
  }
};
